import Store from 'store/store';
import cached from 'utils/cached';
import * as categories from 'utils/gdpr/categories';
import { register, fire } from 'store/bolt/trackingV2';

const getUrl = cached(() => Store.get().appData.meta?.url || location.origin);

register({
	id: 'Carousel engagement',
	trigger: 'custom-carousel-engagement',
	category: 'PERFORMANCE',
	useQueue: true,
	code: (data) => window.firePowsterCustomEvent('carousel-button-click', 'carousel-engagement', data.copy)
});

register({
	id: 'Social Follow',
	trigger: 'social-follow',
	category: 'PERFORMANCE',
	useQueue: true,
	code: (data) => window.firePowsterCustomEvent('social-follow', 'social', data.link)
});

register({
	id: 'Tile Engagement',
	trigger: 'carousel-engagement',
	category: 'PERFORMANCE',
	useQueue: true,
	code: (data) => window.firePowsterCustomEvent('carousel-click', 'carousel-engagement', data.title)
});


register({
	id: 'Hero Engagement',
	trigger: 'hero-engagement',
	category: 'PERFORMANCE',
	useQueue: true,
	code: (data) => window.firePowsterCustomEvent(data.title, 'hero-engagement', data.label)
});

register({
	id: 'Legacy Powster GA event',
	trigger: 'custom-legacy-powster-ga',
	category: 'PERFORMANCE',
	useQueue: true,
	code: ({ action, category, label }) => window.firePowsterCustomEvent(action, category, label)
});
Store.on('POWSTER_GA_EVENT_TRACK', (action, category, label) => fire('custom-legacy-powster-ga', { action, category, label }))

export function trackCarouselEngagement(btn) {
	fire('custom-carousel-engagement', { link: btn.link, copy: btn.btnCopy });
}

export function trackSocialFollow(platform) {
    // Map social platform IDs to their corresponding labels
    const platformLabels = {
        'follow-twitter': 'twitter',
        'follow-facebook': 'facebook',
        'follow-instagram': 'instagram',
        'follow-youtube': 'youtube'
    };

	const label = platformLabels[platform];

    fire('social-follow', { link: platformLabels[platform], label });
}

export function trackTileEngagement(title) {
    fire('carousel-engagement', { title });
}

export function trackTileButtonEngagement(title) {
    fire('carousel-engagement', { title });
}

export function trackHeroEngagement(title, label) {
    fire('hero-engagement', { title, label });
}
